import { BookOpenText, Headphones, UserRound } from 'lucide-react'
import { useEffect } from 'react'
import { Navigate, NavLink, Outlet, Route, Routes, useLocation } from 'react-router-dom'
import { Brand } from './Brand'
import { ActivityPage } from '../pages/ActivityPage'
import { ProfilePage } from '../pages/ProfilePage'
import { ScorePage } from '../pages/ScorePage'
import { TodayPage } from '../pages/TodayPage'

function PageFrame() {
  const location = useLocation()
  useEffect(() => { window.scrollTo(0, 0) }, [location.pathname])
  return <div className="page-frame" key={location.pathname}><Outlet /></div>
}

export function AppShell() {
  return <div className="app-shell">
    <header className="desktop-header"><Brand /><p>Uma obra por vez.</p></header>
    <header className="mobile-header"><Brand /></header>
    <main className="app-main">
      <Routes>
        <Route element={<PageFrame />}>
          <Route index element={<Navigate to="/hoje" replace />} />
          <Route path="/hoje" element={<TodayPage />} />
          <Route path="/atividade/:activityId" element={<ActivityPage />} />
          <Route path="/partitura" element={<ScorePage />} />
          <Route path="/perfil" element={<ProfilePage />} />
          <Route path="*" element={<Navigate to="/hoje" replace />} />
        </Route>
      </Routes>
    </main>
    <nav className="bottom-nav" aria-label="Navegação principal">
      <NavLink to="/hoje"><Headphones /><span>Hoje</span></NavLink>
      <NavLink to="/partitura"><BookOpenText /><span>Sua partitura</span></NavLink>
      <NavLink to="/perfil"><UserRound /><span>Perfil</span></NavLink>
    </nav>
  </div>
}
